import * as React from 'react';
import { FC } from 'react';

import { useSegments } from 'expo-router';
import { StyleSheet } from 'react-native';

import { ZIndex, layout } from 'styles/constants';
import { routes } from 'utils/routing';

import { useServiceModeNotification } from './hooks/use-service-mode-notification';
import TopServiceModeNotificationView from './top-service-mode-notification.view';
import { ITopServiceModeNotificationProps } from './types';

/**
 *
 * TopServiceModeNotification purpose
 *
 */
export const TopServiceModeNotification: FC<React.PropsWithChildren<
  ITopServiceModeNotificationProps
>> = () => {
  const topServiceModeNotificationDetails = useServiceModeNotification();

  const isOnMenuPage = useSegments()?.[0] === routes.menu;

  return (
    !isOnMenuPage &&
    !!topServiceModeNotificationDetails && (
      <TopServiceModeNotificationView
        {...topServiceModeNotificationDetails}
        style={styles.stickyServiceNotification}
      />
    )
  );
};

const styles = StyleSheet.create({
  stickyServiceNotification: {
    width: layout.full,
    zIndex: ZIndex.OVERLAY + 100,
  },
});
